var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235 235c146-147 384-147 530 0 147 146 147 384 0 530-146 147-384 147-530 0-147-146-147-384 0-530zm243 402c-19 0-34 16-34 35v21c2 17 17 30 34 30 19 0 34-15 34-34v-21c-2-17-16-31-34-31zm22-347c-78 0-122 31-122 89 0 19 15 34 34 34s34-15 34-34v-2c1-13 12-19 54-19 35 0 54 17 54 43 0 7-7 17-21 29-10 8-20 14-26 17l-4 2c-9 6-19 14-30 27-18 23-29 53-29 90v15c2 17 17 30 34 30 19 0 34-15 34-34v-18c1-17 7-31 15-41 5-6 9-9 10-10l5-2c10-5 22-13 35-24 27-23 45-49 45-81 0-65-50-111-122-111z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSupport);
export default __webpack_public_path__ + "static/media/ic_support.b047fd1196c90076bad3651d29d6e05b.svg";
export { ForwardRef as ReactComponent };